export const MAX_LENGTH_FULL_NAME = 160;
